
export const POST_ROUTES = [
	{
		title: 'Get List',
		text: 'Get list of posts sorted by creation date.',
		type: 'GET',
		path: '/post',
		paging: true,
		created: true,
		response: 'List(Post Preview)'
	},
	{
		title: 'Get List By User',
		text: 'Get list of posts for specific user sorted by creation date.',
		type: 'GET',
		path: '/user/:id/post',
		paging: true,
		created: true,
		response: 'List(Post Preview)'
	},
	{
		title: 'Get List By Tag',
		text: 'Get list of posts for specific tag sorted by creation date.',
		type: 'GET',
		path: '/tag/:id/post',
		paging: true,
		created: true,
		response: 'List(Post Preview)'
	},
	{
		title: 'Get Post by id',
		text: 'Get post full data by post id',
		type: 'GET',
		path: '/post/:id',
		response: 'Post'
	},
	{
		title: 'Create Post',
		text: 'Create new post, return created post data.',
		type: 'POST',
		path: '/post/create',
		body: 'Post Create (owner and post fields are required)',
		response: 'Post'
	},
	{
		title: 'Update Post',
		text: 'Update post by id, return updated Post data',
		type: 'PUT',
		path: '/post/:id',
		body: 'Post data, (owner field is forbidden to update)',
		response: 'Post'
	},
	{
		title: 'Delete Post',
		text: 'Delete post by id, return id of deleted post',
		type: 'DELETE',
		path: '/post/:id',
		body: '',
		response: 'string'
	}
];
